export const numberFormatter= (num) =>{
    if(num > 999 && num < 1000000){
        return (num/1000).toFixed(0) + 'K'; //  > 1000 < 1 million 
    }else if(num >= 1000000){
        return (num/1000000).toFixed(0) + 'M'; // > 1 million 
    }else if(num < 900){
        return num;
    }
}